import { Injectable } from '@angular/core';
// DKM-5139 Cedric: eski hâli
// import { BYS_GetDocumentContent_Response, BYS_GetDocumentUstYazi_Request } from '../../../models/dtos';
import { BYS_GetDocumentContent_Response, BYS_GetDocumentUstYazi_Request, BYS_GetDocumentUstYaziOnIzleme_Request } from '../../../models/dtos';
import { environment } from '@dabnet-kamu/libs/ui';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UstYaziService {
  constructor(private _httpClient: HttpClient) { }


  
    getUstYazi(belgeKod: number,tarihEkleEh: string) {
      const request = new BYS_GetDocumentUstYazi_Request({
        belgeKod: belgeKod,
        tarihEkleEh: tarihEkleEh
      })
      return this._httpClient.post<BYS_GetDocumentContent_Response>(`${environment.bysService}api/BYS_GetDocumentUstYazi_Request`, request).pipe(
        map((res) => {
          return res as BYS_GetDocumentContent_Response;
        }))
    }

    // DKM-5139 Cedric: taslak (henüz e-imza PDF'i olmayan) giden belgenin içeriği Word'den PDF önizleme olarak alınır.
    // BYS_GetDocumentUstYazi taslakta "Taslak Belgenini henüz üst yazısı yok." döner; önizleme ucu aynı yetki kontrolünü yapar.
    getUstYaziOnIzleme(belgeKod: number, tarihEkleEh: string) {
      const request = new BYS_GetDocumentUstYaziOnIzleme_Request({
        belgeKod: belgeKod,
        tarihEkleEh: tarihEkleEh
      })
      return this._httpClient.post<BYS_GetDocumentContent_Response>(`${environment.bysService}api/BYS_GetDocumentUstYaziOnIzleme_Request`, request).pipe(
        map((res) => {
          return res as BYS_GetDocumentContent_Response;
        }))
    }
  getMimeTypeFromName(name: string): string {
    const lowerCaseName = name.toLowerCase();

    if (lowerCaseName.endsWith('.jpg') || lowerCaseName.endsWith('.jpeg')) {
      return 'jpg';
    } else if (lowerCaseName.endsWith('.png')) {
      return 'png';
    } else if (lowerCaseName.endsWith('.bmp')) {
      return 'bmp';
    }  else if (lowerCaseName.endsWith('.tiff')) {
      return 'tiff';
    } 

    else   {
      return 'pdf';
    }  

  }


  getExtensionFromType(type: string): string {
    const mimeTypes: { [key: string]: string } = {
      'pdf': 'application/pdf',
      'jpg': 'image/jpeg',
      'tiff': 'image/tiff',
      'jpeg':'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'html':'text/html',
      'txt': 'text/plain',
      'csv': 'text/csv',
      'doc': 'application/msword',
      'docx':'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'ppt': 'application/vnd.ms-powerpoint',
      'pptx':'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'xls': 'application/vnd.ms-excel',
      'xlsx':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    };
  
    return mimeTypes[type.toLowerCase()] || 'application/octet-stream';
  }

}
